import React, { useState, useEffect, useRef } from 'react'
import { Skeleton } from 'antd'
import { EditOutlined } from '@ant-design/icons'

import { useCaseViewContext } from '../../context'

import { Item } from "../Item"
import { Container } from "../../Styles"
import { SectionHeader } from '../SectionHeader'
import { StyledButton } from '../Button'
import { PatientBiometricsModal } from './Biometrics/PatientBiometricsModal'

export const Biometrics = ({ patientData, fetchPatientAllergies }) => {
    const { patientDetails, patientDetailsLoading, patientAllergies, patientAllergiesLoading } = patientData || {}
    const { readOnlyMode, apiType } = useCaseViewContext()
    const patient = patientDetails
    const [editModalVisible, setEditModalVisible] = useState(false)
    const [refreshing, setRefreshing] = useState(false)

    function calculateBMI(weight, height) {
        const bmi = (weight / (height ** 2)) * 703;
        return Math.round(bmi);
    }

    const recordedAllergies = patientAllergies?.map(allergy => allergy.name).join(', ') || 'None'
    
    const prevPatientDataRef = useRef(patientDetails)
    
    useEffect(() => {
        if (refreshing && patientDetails && prevPatientDataRef.current !== patientDetails) {
            setRefreshing(false)
            prevPatientDataRef.current = patientDetails
        }
    }, [refreshing, patientDetails])

    const handleEditClick = () => {
        setEditModalVisible(true)
    }

    const handleModalCancel = () => {
        setEditModalVisible(false)
    }

    const handleModalSuccess = () => {
        setEditModalVisible(false)
        setRefreshing(true)
    }

    return (
        <Container>
            <SectionHeader title="Biometrics">
                { (!readOnlyMode || apiType === 'admin') && (
                    <StyledButton 
                        onClick={handleEditClick}
                        tooltip="Edit Biometric Information"
                        Icon={EditOutlined}
                        size="small"
                    />
                )}
            </SectionHeader>
            <Skeleton loading={patientDetailsLoading || !patient || refreshing} active paragraph={{ rows: 6 }}>
                {patient?.heightFt > 0 && <Item label="Height" value={`${patient?.heightFt * 12 + (Number(patient.heightIn) || 0)} in`} />}
                {patient?.weight > 0 && <Item label="Weight" value={`${patient.weight} lbs`} />}
                {patient?.weight > 0 && patient?.heightFt > 0 && <Item label="BMI" value={calculateBMI(patient?.weight, (patient?.heightFt * 12 + Number(patient?.heightIn)))} />}
                <Item label="Blood Pressure" value={patient?.bloodPressure || 'N/A'} />
                <Item 
                    label="Reported Meds" 
                    value={patient?.medications?.split(',').join(' ') || 'None'} 
                    emphasize
                    emphasizeExceptions={["none", "no"]}
                />
                <Item label="Patient-reported Allergies" value={patient?.allergies || 'None'} />
                <Item 
                    label="Recorded Allergies" 
                    value={patientAllergiesLoading ? 'Loading...' : recordedAllergies} 
                />
            </Skeleton>
            
            <PatientBiometricsModal
                visible={editModalVisible}
                onCancel={handleModalCancel}
                onSuccess={handleModalSuccess}
                fetchPatientAllergies={fetchPatientAllergies}
            />
        </Container>
    )
}
